var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.866 1.89A1.733 1.733 0 012.6.157h20.8a1.733 1.733 0 110 3.466H2.6A1.733 1.733 0 01.866 1.89zm0 8.667A1.733 1.733 0 012.6 8.823h20.8a1.733 1.733 0 110 3.467H2.6a1.733 1.733 0 01-1.734-1.733zm0 8.666A1.733 1.733 0 012.6 17.49h20.8a1.733 1.733 0 110 3.467H2.6a1.734 1.734 0 01-1.734-1.734z",
    fill: "currentColor"
  })));
}
export default SvgHamburgerinline;